import CardHeader from './cardHeader';
import VarianceIndicator from './varianceIndicator';
import { ImpactCardInterface, ImpactCardRow } from '../../types/global';
import Description from './description';
import useStreetviewFilterNavigation from '../../hooks/useNavigateUpdateFilters';

const NA = 'NA';
export default function ImpactCard({ impactCardData }: { readonly impactCardData: ImpactCardInterface }) {
  const updateFiltersAndRedirect = useStreetviewFilterNavigation();

  return (
    <div id="impact-card-container" className="flex flex-col grow in-w-[150px] flex-1 card font-normal">
      <CardHeader text={impactCardData.title} icon={impactCardData.icon} redirectUrl={impactCardData.url} />
      <div id="impact-row-container" className="flex-1">
        {
        impactCardData.impactAreas.map(({
          title, value, filters, description, descriptionFilters, variance, trend
        }: ImpactCardRow) => (
          <div key={title} id="impact-card-row" className="flex flex-col grow p-2 gap-2 first:border-t last:border-none border-b border-pipgrey-light">
            <div className="flex lg:flex-row flex-col justify-between items-start gap-1">
              <span className="text-sm">
                {title}
              </span>
            </div>
            <div className="flex flex-row gap-3 items-center">
              {
                   filters ? (
                     <button
                       type="button"
                       onClick={() => updateFiltersAndRedirect(filters)}
                       className="lg:text-xl text-lg font-semibold hover:text-primary cursor-pointer hover:underline"
                     >
                       {value}
                     </button>
                   ) : (<span className="lg:text-xl text-lg font-semibold">{value}</span>
                   )
              }
              {!variance || variance === NA
                ? null : (<VarianceIndicator variance={variance} trendUpward={trend || ''} />
                )}
            </div>
            <Description description={description} descriptionFilters={descriptionFilters} />
          </div>
        ))
      }
      </div>
    </div>
  );
}
